import { type Message, MessageSeverity, MessageType } from './types';
import { isAppliedMessage } from './utils';

const REMOVAL_OR_ERROR_TYPES = [
  MessageType.NonsaleableProductRemoval,
  MessageType.ExpiredProductRemoval,
];

const isRemovalOrError = (message: Message) =>
  message.severity === MessageSeverity.Error ||
  (message.type && REMOVAL_OR_ERROR_TYPES.includes(message.type));

const isAvailableItemDiscount = (message: Message) =>
  !isAppliedMessage(message) && message.type === MessageType.DiscountVolume;

// Preserves the current visual ordering: warnings/site-wide banners first,
// then applied discounts, then available item discounts, then removals/errors last.
export const groupDiscountMessages = (messages: Message[]) => {
  const othersBefore: Message[] = [];
  const applied: Message[] = [];
  const availableItemDiscounts: Message[] = [];
  const othersAfter: Message[] = [];

  messages.forEach((message) => {
    if (isAppliedMessage(message)) {
      applied.push(message);
    } else if (isAvailableItemDiscount(message)) {
      availableItemDiscounts.push(message);
    } else if (isRemovalOrError(message)) {
      othersAfter.push(message);
    } else {
      othersBefore.push(message);
    }
  });

  return { othersBefore, applied, availableItemDiscounts, othersAfter };
};

// Shortens the English copy for applied-discount lines by dropping "have been", e.g.
// "Small stickers have been discounted by 25%." -> "Small stickers discounted by 25%."
// Text is served pre-translated from the monolith, so this is a no-op for other locales.
export const shortenAppliedDiscountText = (text: string): string =>
  text.replace(/\shave been\s/i, ' ');
